<template>
	<div class="container">



		<div class="content">

			<div>
				<section style='position:relative'>

					<extra-modal
						ref="modalExtra"
						:action="false"
					/>

					<div v-if="!$mq.isDesktop()">
						<br><br><br><br>
					</div>

					<div class="section-container-ct" :class="{'sticky': sticky}">
						<SliderQ
							v-if="sections.length > 0"
							:maxNumSlides="sections.length"
							:minSizeOfSlide="110"
							class="section-container"
							:arrows="!$mq.isDesktop()"
						>
							 <slide
					        	v-for="(section, index) in sections" 
					        	:class="{'active': index == sectionEnabled}" 
					        	class="section-item" 
					        	@click="changeSection(index)"
					        >
						        <div :class="{'section-container-box': $mq.isDesktop() }" >
									<img v-if="$mq.isDesktop() && !sticky" :src="index != sectionEnabled ? section.icon.default || '' : section.icon.active || ''" width='56' height='56' />
									<span>{{ section.name }} </span>
								</div>
					        </slide>

						</SliderQ>
						<div class="border-top-checkout"> </div>
					</div>

					<div v-if="$mq.isDesktop()" style='height: 150px'></div>
					<div class="slick-content slick-ct">
						<div v-for="(section, index1) in sections" style='padding: 0 20px'>

							<div v-if="section.type == 'shop'" :class="{'hide': index1 != sectionEnabled}">
								<template>

									<h2 class="center">{{ section.title || "Title is missing in section" }}</h2>
									<p class="center">{{ section.subtitle || "Subtitle is missing in section" }}</p>

									<div class="recipes-listing">
										<extra-box
											class="recipe-box"
											v-for="(product, index) in getProductsByTags(section.tags)"
											:key="index"
											:item="product"
											@openModalExtra="$refs.modalExtra.open(product)"
											:maxAvailable="section.max >= 0 ? section.max : 999"
											:action="false"
										>
										</extra-box>
									</div>
								</template>
							</div>

							<div v-if="section.type == 'menu'" :class="{'hide': index1 != sectionEnabled}">
								<template
									v-for="(week, num) in weeks"
									v-if="+num === +weekToShow && week && week.id"
								>
									<div class="flex title" :key="num">
										<h2>
											<i
												id='week-plan-prev'
												class="fa fa-angle-left"
												@click="showPrevWeek()"
												:invisible="!(weekToShow > 0 && weeks[+weekToShow-1].active) || (menuPreview && menuPreview.active)"
											/>
										</h2>

										<h2
											:class="{ 'placeholder-line': !week.id }"
											v-html="week.id && $t('components.recipes.' + weekSrc(num) + '.title',
												{
													from: `${$_dates_readableDay(week.date.start)} ${($_dates_readableMonth(week.date.start) !== $_dates_readableMonth(week.date.to) ? $_dates_readableMonth(week.date.start) : '')}`, 
													to: `${$_dates_readableDay(week.date.to)} ${$_dates_readableMonth(week.date.to)}`
												})"
										/>

										<h2>
											<i
												id='week-plan-next'
												class="fa fa-angle-right"
												@click="showNextWeek()"
												:invisible="!(weekToShow < 2 && weeks[+weekToShow+1].active) || (menuPreview && menuPreview.active)"
											/>
										</h2>
									</div>
									<p
										class="subtitle"
										:class="{ 'placeholder-line': !week.id }"
										:key="'subtitle-' + num"
										v-html='week.id && $t("components.recipes." + weekSrc(num) + ".subtitle")'
									/>
									<div
										class="recipes-listing"
										:key="'listin-' + num"
									>
										<recipe-box
											v-for="(recipe, index) in week.recipes"
											:item="recipe"
											@openRecipe="openRecipe"
											isHover
											:isLoading="(recipeLoading && recipe.id === loadingId)"
											:key="index"
											:wishlist="+num === 1"
											@addToWishList="$_wishlist_action"
											:isOnWishlist="$_wishlist_isOnWishlist(recipe)"
										/>
										
										<loading-placeholder
											class="recipe-box"
											v-if="!week.recipes"
											v-for="n in 6"
										/>

										<div v-if="!week.active">
											<br><br>
											Menù non disponibile.
											<br><br>
										</div>
									</div>
								</template>

							</div>
						</div>
					</div>

				</section>
			</div>
			<section class="center">
				<usp :template="'recipes'">
					<h2
						slot="titles"
						class="center"
						v-html='$t("components.usp.recipes.title")'
					/>
				</usp>
				<router-link
					:to="{name: 'how-we-create'}"
					class="link-detail"
					target="_blank"
					v-html="`Scopri come creiamo le ricette`"
				/>
			</section>
			<section>
				<opinions
					:template="'recipes'"
				/>
			</section>
		</div>

		<wishlist-widget
			:wishlistMode="wishlistMode"
			:wishlistRecipes="$_wishlist_wishlistRecipes"
			:wishlist="wishlist"
			:link="$_wishlist_wishlistLink"
		/>

		<start-with-us />
	</div>
</template>

<script>

import StartWithUs from './Parts/StartWithUs'
import RecipeBox from './RecipeBox'
import MenuAlert from './Checkout/MenuAlert'
import Opinions from './Opinions'
import Usp from './Usp'
import { Extras } from '../core/Extras'
import ExtraBox from './Ecommerce/ExtraBox'
import ExtraModal from './Ecommerce/ExtraModal'

import WishlistWidget from './SocialShare/WishlistWidgetNR'

import { WeekPlanApi } from '../api/WeekPlanApi'
import { RecipeApi } from '../api/RecipeApi'
import { ExtraApi } from '../api/ExtraApi'
import { Recipe } from '../core/Recipe'
import { Menu } from '../core/Menu'
import { container } from '../services/container'

import { dates } from '../mixins/dates'
import { wishlist } from '../mixins/wishlist'

import { menuStore } from '../store/menuStore' 

export default {
	data () {
		return {

			weekToShow: 1,

			prevWeek: {},
			nextWeek: {},

			menuStore: menuStore.state,
			menuPreview: {},

			recipeLoading: false,
			loadingId: null,
			sectionEnabled: 0,
			sections: [],

			products: [],

			sticky: false,
		}
	},

	mixins: [
		dates,
		wishlist
	],

	watch: {
		'menuStore.active': {
			handler () {
				menuStore.redirectHandler()
				if (this.menu && !this.menu.active) {
					this.loadWeekById(231)
				}
			},
			immediate: true
		}
	},

	components: {
		Usp,
		Opinions,
		MenuAlert,
		RecipeBox,
		StartWithUs,
		WishlistWidget,
		ExtraBox,
		ExtraModal
	},

	computed: {	
		user () {
			this.$root.user
		},

		menu () {
			return this.menuStore.menu
		},

		weeks () {
			return {
				0: this.prevWeek,
				1: this.menu && this.menu.active ? this.menu : this.menuPreview,
				2: this.nextWeek
			}
		},
	},

	methods: {
		load () {


			return this.loadCurrentWeek()
			.then(r => {
				this.sections = JSON.parse(window.config["quomi.checkout-top-sections"])

				if (container.get('source').getValue()) {
					this.sections = this.sections.filter(i => {
						return i.source && i.source.indexOf(container.get('source').getValue()) !== -1
					})
				} else {
					this.sections = this.sections.filter(i => {
						return !i.source
					})
				}
			
				this.loadSections()
				return this.loadProducts()
			})
			.then(response => {
				 
				this.loadPrevWeek()
				this.loadNextWeek()
				
			})
		},
		changeSection(i) {

			window.scrollTo(0, 0);
        	$( '.slick-content' )[0].slick.slickGoTo(i);
			this.sectionEnabled = i
		},

		getShopTags () {

			let tags = [];
			this.sections.map(i => {
				tags = tags.concat(i.tags || [])
			})


			return tags
		},
 

		loadWeekById(id) {
			var weekApi = new WeekPlanApi()
			return weekApi.week({ id: id })

			.then(response => {
				this.menuPreview = new Menu(response.body.data.resource)
			})
		},

		loadCurrentWeek () {
			return menuStore.loadCurrentMenu()
		},

		loadPrevWeek () {
				return this.weekApi.prev({})

			.then(response => {
				this.prevWeek = new Menu(response.body.data.resource)
			}) 
		},

		loadNextWeek () {
				return this.weekApi.next({})

			.then(response => {
				this.nextWeek = new Menu(response.body.data.resource)
			})
		},

		weekSrc (num) {
			if (+num === 0) return 'prev_week'
			if (+num === 1) return 'current_week'
			if (+num === 2) return 'next_week'
		},

		loadSections () {

			setTimeout((i) => {
				
				$(".slick-content").slick({
					autoplay: false,
					arrows: false,
					swipe: false,
					touchMove: false
				});



				$('.slick-content').on('swipe', (event, slick, direction) => {
				  this.sectionEnabled = slick.currentSlide
				});

			}, 100)

		},
		showNextWeek () {
			if (!(this.weekToShow < 2 && this.weeks[+this.weekToShow+1].active)) return
			this.weekToShow++
		},

		showPrevWeek () {
			if (!(this.weekToShow > 0 && this.weeks[+this.weekToShow-1].active)) return
			this.weekToShow--
		},

		getProductsByTags(tags) {

			return this.products.filter(product => {
				return product.tags.some(r=> tags.includes(r))
			}).sort((a,b) => {
				return a.price - b.price;
			})
		},

		loadProducts() {

			var tags = this.getShopTags();

			var em = new ExtraApi()

			return em.all({
				params: {
					show: 99999,
					page: 1,
					sort_direction: 'asc',
					query: `shopTags.name in (${tags.map(i => `'${i}'`).join(",")})`
				}
			})
			.then(response => {
				this.products = new Extras(response.body.data.resources)
			})
		},
		openRecipe (id) { 
	    	this.recipeLoading = true 
	    	this.loadingId = id 
	    	return this.recipeApi.recipe(id)

	    	.then(response => { 
	        	var recipe = new Recipe(response.body.data.resource) 
	 
	    		var url = recipe.url ? recipe.url : recipe.id 
	    		this.$router.push({ name: 'recipe', params: { id: url } }) 
	        	this.recipeLoading = false 
	      	}) 
	    }
	},

	mounted () {
		this.weekApi = new WeekPlanApi()
		this.recipeApi = new RecipeApi()
		return this.load()
	},
	created () {
		var currentPosition = 0
		window.addEventListener('scroll', (e) => {
			var scrollDown = () => window.scrollY > currentPosition && window.scrollY > 100
			this.sticky = !!scrollDown()
			currentPosition = window.scrollY
		})
	}
}
</script>

<style>
	.slick-slide {
		outline: none !important;
	}
	.slick-track {
	    margin: auto;
	}
	.slider-arrow {
		box-shadow: none !important;
	}
	.items-container {
		padding: 0 !important;
	}

	.slick-slide:not(.slick-active) {
	    height: 0;
	}
</style>
<style scoped>

	section {
		padding: 0 0 30px 0;
	}

	[invisible] {
		visibility: hidden;
	}

	.placeholder-line {
		height: 30px;
		width: 100%;
		background-color: #ededed;
	}

	.title h2 {
		margin-bottom: 0;
		text-align: center;
	}

	.title {
		justify-content: center;
		align-items: center;
	}

	.subtitle {
		margin: 10px 0;
		text-align: center;
	}

	.content {
		max-width: 1200px;
	}

	.content.banner {
		padding-top: 50px;
	}

	.fa.fa-angle-right,
	.fa.fa-angle-left {
		cursor: pointer;
		font-weight: bold;
		padding: 15px 30px;
	}

	.recipes-listing {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		margin: 0 -10px;
		align-items: flex-start;
	}

	.recipe-box {
		flex-basis: calc(100% / 3 - 20px);
		max-width: calc(100% / 3 - 20px);
		margin: 10px;
		position: relative;
	}

	.recipe-modal .recipe-name {
		font-size: 20px;
		padding: 10px 0;
	}

	@media (max-width: 1024px) {
		.fa.fa-angle-right {
			padding: 15px 3px 15px 15px;
		}

		.fa.fa-angle-left {
			padding: 15px 15px 15px 3px;
		}

		.recipe-box {
			flex-basis: calc(100% / 2 - 20px);
			max-width: calc(100% / 2 - 20px);
		}

	}

	@media (max-width: 626px) {
		.content.banner {
			padding-top: 70px;
		}
	}

	@media (max-width: 600px) {
		.recipe-box {
			flex-basis: calc(100% / 1 - 20px);
			max-width: calc(100% / 1 - 20px);
		}
	}

	@media (max-width: 324px) {
		.content.banner {
			padding-top: 100px;
		}
	}



.section-container {
	margin: 10px auto 0 auto;
}

@media (max-width: 900px) {
	.section-container {
		width: 100%;
	}
}



.section-item {
	text-align: center;
	cursor: pointer;
	outline: none !important;
	margin: 0 !important;
}


@media (max-width: 1024px) {

	.section-item.active {
		border-bottom: 2px solid var(--quomi-primary);
	}

	.section-item {
		padding-bottom: 10px;
	}

	.section-item span{
		margin-top: 10px;
	}
}


.section-item span{
	display: block;
	color: #54545b;
	font-size: 15px;

	font-weight: 700;
	text-transform: capitalize;
}

.section-item.active span{
	color: var(--quomi-primary);
}


.section-container-box {
	width: 110px;
	border:2px solid transparent; 
	padding: 5px; 
	display: inline-block;
	border-radius: 10px;
}

.section-container-ct:not(.sticky) .section-item.active .section-container-box {
	border:2px solid var(--quomi-primary); 
}


.section-container-ct {
	margin-top: -30px;
	margin-bottom: 20px;
	position: fixed !important;
	left: 0;
	width: 100%;
	z-index: 2;
	background: white;
}


.section-container-ct.sticky {
	margin-top: -110px;
}

.border-top-checkout {
	margin-top: -2px;
	border-top: 2px solid grey
}

@media (min-width: 1024px) {

	.border-top-checkout {
		margin-top: 10px;
	}
}

@media (max-width: 1024px) {

	.slick-ct {
		padding-top: 60px;
	}

	.section-container-ct {
		margin-top: -125px;
	}


	.section-container-ct.sticky {
		margin-top: -170px;
	}

}
</style>
